export const loadCode1 = `
import { motion } from 'framer-motion'

const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            delayChildren: 0.3,
            staggerChildren: 0.2
        }
    }
};

const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1
    }
};


<motion.ul
    key={key}
    className="container"
    variants={container}
    initial="hidden"
    animate="visible"
>
    {[0, 1, 2, 3].map((index) => (
    <motion.li key={index} className="item" variants={item} />
    ))}
</motion.ul>

`

export const loadCode2 = `
import { motion } from 'framer-motion'

<motion.div
    initial={{ opacity: 0, x: 200 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5 }}
></motion.div>

`

export const loadCode3 = `
import { motion } from 'framer-motion'

<motion.div
    initial={{ opacity: 0, x: 200 }}
    viewport={{ once : true }} // only trigger once when in view
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5 }}
></motion.div>

`